module.exports = __webpack_public_path__ + "img/statistics.17ceca0f.png";